var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcQuizzesBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#303D4D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.429 7.765)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.104,
    cy: 2.824,
    rx: 1.104,
    ry: 1.059
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.736,
    width: 1,
    height: 2.471,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.348 2.924v-.806h-.352a1.059 1.059 0 1 1 0-2.118h3.525a1.059 1.059 0 0 1 0 2.118H9.17v.872a7.59 7.59 0 0 1 5.996 7.422A7.585 7.585 0 0 1 7.582 18 7.585 7.585 0 0 1 0 10.412a7.589 7.589 0 0 1 6.348-7.488Zm1.234 12.958a5.468 5.468 0 0 0 5.467-5.47 5.468 5.468 0 0 0-5.467-5.47 5.468 5.468 0 0 0-5.466 5.47 5.468 5.468 0 0 0 5.466 5.47Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuizzesBlack);
export default __webpack_public_path__ + "static/media/ic-quizzes-black.21a1d87c72b7c4c348313681c6734a04.svg";
export { ForwardRef as ReactComponent };